
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const MiniFaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Cuánto tiempo tarda la instalación de pladur?',
      answer: 'Depende del proyecto, pero un tabique estándar se puede instalar en 1-2 días. Un falso techo en una habitación suele tardar 2-3 días. Te daremos un plazo exacto en el presupuesto.',
    },
    {
      question: '¿Trabajáis en viviendas ocupadas?',
      answer: 'Sí, trabajamos habitualmente en viviendas y oficinas ocupadas. Mantenemos el espacio limpio y ordenado, y coordinamos los horarios para minimizar las molestias.',
    },
    {
      question: '¿Qué incluye el presupuesto?',
      answer: 'El presupuesto incluye materiales, mano de obra, transporte y limpieza. Detallamos todos los conceptos para que sepas exactamente qué estás contratando.',
    },
    {
      question: '¿Ofrecéis garantía en vuestros trabajos?',
      answer: 'Sí, todos nuestros trabajos de instalación de pladur en Barcelona incluyen garantía de calidad. Usamos materiales de primera y técnicas profesionales.',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-primary-dark text-5xl md:text-6xl font-serif font-bold mb-6">
            Preguntas frecuentes
          </h2>
          <p className="text-gray-600 text-lg">
            Resolvemos las dudas más comunes sobre nuestros servicios de pladur.
          </p>
        </motion.div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-300"
              >
                <h3 className="text-primary-dark text-lg font-bold pr-4">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0 w-8 h-8 rounded-full border-2 border-blue-200 flex items-center justify-center">
                  <motion.i
                    animate={{ rotate: openIndex === index ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                    className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-primary text-xl`}
                  ></motion.i>
                </div>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-8 pb-6">
                      <p className="text-gray-600 text-[15px] leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <Link
            to="/faq"
            className="inline-flex items-center space-x-2 text-primary font-semibold hover:underline"
          >
            <span>Ver todas las preguntas frecuentes</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default MiniFaqSection;
